import { render } from "./Event.vue?vue&type=template&id=1217b8f5&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=1217b8f5&lang=scss&scoped=true"
import "./Event.vue?vue&type=style&index=1&id=1217b8f5&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1217b8f5"]])

export default __exports__